import createDuck from '../../../lib/ducks/remoteDuck'
import Country from '../../../lib/api/country'

export default createDuck({
  namespace: 'user',
  store: 'country',
  fetchCallback: (options) => Country.getCountry(options),
})
